import React from 'react'

const WM_RhineUserManual = () => {

  return (
    <div style={{ width: '100%', height: '100vh',margin: 'auto' }}>
      <iframe src='https://privacypolicygodrejsmartlife.s3.ap-south-1.amazonaws.com/WM-Rhine-GODREJ+SMART+LIFE+APP+USER+MANUAL.pdf'  title="PDF Viewer"
        width="100%"
        height="100%"
        style={{ border: 'none',overflow:'auto', backgroundColor:'white' }}></iframe>
    </div>
  )
}

export default WM_RhineUserManual;